(()=>{
  const grid=document.querySelector('[data-bf-grid]');if(!grid)return;
  document.documentElement.classList.add('bf-coll-js');
  const END=Date.parse('2026-12-01T00:00:00+02:00');
  const ORDER=['hook','timer','benefits','help'];
  const tpl=n=>document.getElementById('bf-strip-'+n).content.firstElementChild.cloneNode(true);
  const cols=()=>Math.max(1,getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
  const io='IntersectionObserver' in window?new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}}),{rootMargin:'0px 0px -10% 0px'}):null;
  const arm=el=>{if(!io||matchMedia('(prefers-reduced-motion: reduce)').matches)return;if(el.getBoundingClientRect().top>innerHeight){el.classList.add('is-armed');io.observe(el);setTimeout(()=>el.classList.add('is-in'),6000);}};
  function layout(){
    const strips=[...grid.querySelectorAll(':scope>.bf-strip')];strips.forEach(s=>s.remove());
    const items=[...grid.querySelectorAll(':scope>li')];const step=cols()*2;let k=0;
    for(let i=step;i<items.length;i+=step){
      const s=strips.shift()||tpl(ORDER[k%ORDER.length]);s.dataset.kind=s.dataset.kind||ORDER[k%ORDER.length];
      items[i-1].after(s);k++;if(!s.dataset.armed){s.dataset.armed='1';arm(s);}
    }
    tick();
  }
  const p=n=>String(n).padStart(2,'0');
  function tick(){let s=Math.max(0,Math.floor((END-Date.now())/1000));
    grid.querySelectorAll('[data-bf-clock]').forEach(c=>{c.querySelector('[data-d]').textContent=p(Math.floor(s/86400));c.querySelector('[data-h]').textContent=p(Math.floor(s%86400/3600));c.querySelector('[data-m]').textContent=p(Math.floor(s%3600/60));c.querySelector('[data-s]').textContent=p(s%60);});}
  setInterval(tick,1000);
  grid.addEventListener('click',e=>{const a=e.target.closest('[data-bf-next]');if(!a)return;e.preventDefault();const strip=a.closest('.bf-strip');let n=strip.nextElementSibling;while(n&&n.classList.contains('bf-strip'))n=n.nextElementSibling;(n||strip).scrollIntoView({behavior:'smooth',block:'start'});});
  // infinite scroll
  const pag=document.querySelector('.collection__pagination');
  let nextUrl=pag&&pag.querySelector('.next a')?pag.querySelector('.next a').href:null;
  const more=document.querySelector('[data-bf-more]');let busy=false;
  async function load(){
    if(busy||!nextUrl)return;busy=true;more.querySelector('.bf-more__spinner').hidden=false;more.querySelector('.bf-more__btn').hidden=true;
    try{const r=await fetch(nextUrl,{credentials:'same-origin'});const html=await r.text();const doc=new DOMParser().parseFromString(html,'text/html');
      const g=doc.querySelector('[data-bf-grid]');[...g.querySelectorAll(':scope>li:not(.bf-strip)')].forEach(li=>grid.appendChild(document.adoptNode(li)));
      const nx=doc.querySelector('.collection__pagination .next a');nextUrl=nx?new URL(nx.getAttribute('href'),location.origin).href:null;
      layout();
    }catch(err){more.querySelector('.bf-more__btn').hidden=false;}
    busy=false;more.querySelector('.bf-more__spinner').hidden=true;
    if(!nextUrl){more.querySelector('.bf-more__btn').hidden=true;more.querySelector('.bf-more__done').hidden=false;obs&&obs.disconnect();}
    else if(more.getBoundingClientRect().top<innerHeight+800){setTimeout(load,60);}
  }
  let obs=null;
  if(more){
    if(!nextUrl){more.querySelector('.bf-more__done').hidden=false;}
    else{more.hidden=false;more.querySelector('.bf-more__btn').addEventListener('click',load);
      if('IntersectionObserver' in window){obs=new IntersectionObserver(es=>{if(es[0].isIntersecting)load();},{rootMargin:'800px 0px'});obs.observe(more);}else{more.querySelector('.bf-more__btn').hidden=false;}}
  }
  let rt;addEventListener('resize',()=>{clearTimeout(rt);rt=setTimeout(layout,200);});
  layout();
})();
